$(document).ready(function () {


	$(".register-drawer").hide();
	$(".cstm-register").click(function () {
		$(".cstm-login-form").hide();
		$(".register-drawer").show();
	});
	$(".cstm-signin").click(function () {
		$(".cstm-login-form").show();
		$(".register-drawer").hide();
	});
	$(".variant-image-container img").click(function () {
		var imgalt = $(this).attr("alt");
		$(".variant-input input").each(function () {
			var variant = $(this).attr("data-handle");
			if (imgalt == variant) {
				$(this).trigger("click");
				$("html, body").animate({ scrollTop: 0 }, "slow");
				return false;
			}
		});
	});

	$(".variant-input input").click(function () {
		var variant = $(this).attr("data-handle");

      
		$(".variant-image-media").each(function () {
			var imgalt = $(this).attr("data-variant-color");
			if (variant != imgalt) {
				$(this).addClass("selected-variant");
			} else {
				$(this).removeClass("selected-variant");
			}
		});


        $(".variant-images__slider").hide();
        $(".variant-images__slider").removeClass("selected-variant");
        $("#variant-"+variant+".variant-images__slider").show();
        $(".variant-images__slider").slick('slickAdd');
	});
});

let variantFormSelects = document.querySelectorAll(".variant-input input");

variantFormSelects.forEach((vfs) => {
	vfs.addEventListener("click", (e) => {
		let targetTag = e.target.dataset.handle;
		let featuredImages = document.querySelectorAll(".variant-featured-image-container");
		featuredImages.forEach((el) => {
			if (el.dataset.variantAltTag == targetTag) {
				el.classList.remove("selected-variant");
			} else {
				el.classList.add("selected-variant");
			}
		});
	});
});

function filterVariantImages() {
	let activeOption = document.querySelector(".custom-input.active");
	let activeVariantImagesTag = activeOption.dataset.handle;
	var variant = activeVariantImagesTag;
	$(".variant-image-media").each(function () {
		var imgalt = $(this).attr("data-variant-color");
		// console.log("ImageAlt=", imgalt);
		if (variant != imgalt) {
			$(this).addClass("selected-variant");
		} else {
			$(this).removeClass("selected-variant");
		}
	});
}
filterVariantImages();


